import Vue from 'vue'
import Vuex from 'vuex'
// import gsap from 'gsap'
import bladeAnimations from './helpers/bladeAnimations.js'

import {introAnimation} from './helpers/blade1.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	blade1: {
		type: 'Hero',
		variant: '',
		classes: '',
		learnMore: 'Learn more',
		transitions: {
			aos: {
				title: {
					type: 'fade-left', 
					duration: 2000, 
					delay: 2000
				},
				subtitle: {
					type: 'fade-left', 
					duration: 2500, 
					delay: 3000
				},
			},
			gsap: {
				components: [],
				script: introAnimation,
			}
		},
		presentation: {
			fullwidth: true,
			textalignment: 'text-left',
			contentleft: true,
			graphicalignment: 'text-center',
			primarycta: false,
			secondarycta: false,
			bgvideo: true,
			backgroundaction: 'scroll',
			ani: 'headline'
		},
		content: {
			title: 'Pushing games <br>to the edge',
			subtitle: 'Welcome to the new era of cloud gaming.',
			eyebrow: '',
			text: '',
			graphic: '',
			quote: '',
			primaryctaurl: '',
			primaryctatext: '',
			secondaryctaurl: '',
			secondaryctatext: '',
			backgroundtype: 'video',
			backgroundimage: require("@/assets/images/Video-Header-Placeholder.jpg"),
			videopath: require("@/assets/videos/Video-Header-Compressed.mp4"),
		}
	},
	blade2a: {
		title: 'The need for speed.',
		paragraphs: [
		'As everyone in business knows, customers expect greatness and they usually want it quickly. Customers of video gaming companies are no different.Gamers have high expectations and game play performance is key. For them, latency isn’t just a technical term; it’s something they feel as they play, and it can make or break the overall experience.',
		'So when you propose a new cloud-based game streaming technology, you’d better come up with an effective way to deliver an ultralow-latency experience. Bethesda has the answer.'
		],
		gC: {
			type: 'GroupContainer',
			variant: '',
			classes: 'blade-2a-group-cntnr',
			transitions: {
				aos: {
					name: '',
					delay: '',
					duration: ''
				},
				gsap: {
					components: [],
					script: ''
				}
			},
			presentation: {
				fullWidth: true,
				backgroundAction: 'scroll'
			},
			content: {
				backgroundColor: '',
				backgroundImg: '',
				backgroundVid: '',
				backgroundVidTab: '',
				backgroundVidMob: ''
			}
		},
		eBF1: {
			type: 'EightByFour',
			variant: '',
			classes: '',
			transitions: {
				aos: {
					name: '',
					delay: '',
					duration: ''
				},
				gsap: {
					components: [],
					script: ''
				}
			},
			presentation: {
				direction: 48
			},
			content: {},
		}
	},
	blade2b: {
			gC: {
				type: 'GroupContainer',
				variant: '',
				classes: 'blade-2b-group-cntnr',
				transitions: {
					aos: {
						name: '',
						delay: '',
						duration: ''
					},
					gsap: {
						components: [],
						script: ''
					}
				},
				presentation: {
					fullWidth: false,
					backgroundAction: 'scroll'
				},
				content: {
					backgroundColor: '#000000',
					backgroundImg: '',
					backgroundImgTab: ''
				}
			},
			simpQ: {
				type: 'SimpleQuote',
				variant: '',
				classes: 'blade-2b-simple-quote',
				transitions: {
					aos: {
						name: '',
						delay: 0,
						duration: 0
					},
					gsap: {
						components: [],
						script: ''
					}
				},
				presentation: {
					quoteTextAlignment: 'text-left',
					quoteContainer: 'col-10',
					hascitelink: false,
				},
				content: {
					quote: '<span class="large-quotes"></span>You basically want to feel like you’re not streaming. You just want it to feel like you’re actually in the game.',
					quoteCitation: '',
					citelink: ''
				}
			},
			shaleHeadshot: require("@/assets/images/Shale-Headshot.png"),
	},
	blade3: {
		title: 'With Orion, Bethesda is changing the game.',
		paragraphs: [
			'Bethesda, a pioneer in the gaming world with some of the biggest titles in the industry, is continually raising the bar. When its subsidiary, id Software, began building a cloud-gaming software platform, the company knew that anything less than exceptional performance was unacceptable. Bethesda and id wanted to give players the ability to stream their favorite games on any device, anywhere, at any time—all at 60 frames per second in 4K resolution.',
			'From that research and development, Orion was born—game-engine-level technology designed to optimize performance in the cloud. For testing this new Orion technology, Bethesda chose its award-winning first-person-shooter DOOM (2016). The results were impressive: dramatic latency reductions of up to 20% per frame and requiring up to 40% less bandwidth.',
			'And that’s just the beginning.'
		],
		ctatarget: '_blank',
		backgroundVideo: require("@/assets/videos/Gameplay_White_BG_-_Feb_4.mp4"),
		backgroundVideoAltText: 'The video game DOOM, displayed on a smartphone mounted on a Bluetooth® controller.',
		transitions: {
			aos: {
				title: {
					name: 'fade-left',
					delay: '',
					duration: ''
				}
			},
		},
		gC: {
			type: 'GroupContainer',
			variant: '',
			classes: 'blade-3-group-cntnr',
			transitions: {
				aos: {
					name: '',
					delay: '',
					duration: ''
				},
				gsap: {
					components: [],
					script: ''
				}
			},
			presentation: {
				fullWidth: true,
				backgroundAction: 'scroll'
			},
			content: {
				backgroundVid: '',
				backgroundVidTab: '',
				backgroundVidMob: ''
			}
		},
		eBf: {
			type: 'SixBySix',
			variant: '',
			classes: '',
			transitions: {
				aos: {
					name: '',
					delay: '',
					duration: ''
				},
				gsap: {
					components: [],
					script: ''
				}
			},
			presentation: {
				direction: 84
			},
			content: {
				posterUrl: '',
				backgroundVideo: require("@/assets/videos/Gameplay_White_BG_-_Feb_4.mp4"),
			},
		},
	},
	blade4: {
		title: 'Verizon and AWS improve Orion’s performance.',
		seeTitle: 'See how Verizon 5G Edge and AWS can bring groundbreaking cloud performance.',

		paragraphs: [
			'Bethesda’s and id’s innovations have driven Orion’s performance. As id Software CTO Robert Duffy says, “Our patented set of technologies are really geared at saving bandwidth and compute on the cloud—and delivering a console experience or better to gamers.” But Duffy believes Verizon 5G Edge, a groundbreaking multi-access edge compute platform that unites Verizon’s 5G network with the industry-leading cloud services of Amazon Web Services (AWS), will be a catalyst for even greater improvements.',
			'That’s because the power of 5G is made that much greater when it’s combined with powerful edge computing resources. According to the FCC Technological Advisory Council, when done right, 5G and edge computing have the potential to reduce the round-trip time for processing data by up to two orders of magnitude. That’s huge.'
		],
		ctatarget: '_blank',
		playVideoTitle: 'Play video',
		showcasePlaceholder: require("@/assets/images/Video-Thumbnail.jpg"),
		backgroundVideo: require("@/assets/videos/Gameplay_White_BG_-_Feb_4.mp4"),
		closedCaptioning: "/video.vtt",
		showcase: require("@/assets/videos/Verizon_Bethesda_200113B_720p_1mbps.mp4"),
		duffy: 
		{
			text: 'With Verizon 5G, it’s like we can get this to your gamers and their devices pretty much at the speed of light.',
			name: '—Robert Duffy',
			title: 'Chief Technology Officer, id Software',
			photo: require("@/assets/images/Duffy.png"),
			altText: 'Portrait of Robert Duffy, the chief technology officer at id Software',
			background: require("@/assets/images/Duffy-Background.png"),
		},
		transitions: {
			aos: {
				title: {
					name: 'fade-left',
					delay: '',
					duration: ''
				}
			},
		},
		gC: {
			type: 'GroupContainer',
			variant: '',
			classes: 'blade-4-group-cntnr',
			transitions: {
				aos: {
					name: '',
					delay: '',
					duration: ''
				},
				gsap: {
					components: [],
					script: ''
				}
			},
			presentation: {
				fullWidth: true,
				backgroundAction: 'scroll'
			},
			content: {
				backgroundVidTab: '',
				backgroundVidMob: ''
			}
		},
		eBf: {
			type: 'SixBySix',
			variant: '',
			classes: '',
			transitions: {
				aos: {
					name: '',
					delay: '',
					duration: ''
				},
				gsap: {
					components: [],
					script: ''
				}
			},
			presentation: {
				direction: 84
			},
			content: {
				posterUrl: '',
				backgroundVideo: require("@/assets/videos/Gameplay_White_BG_-_Feb_4.mp4"),
			},
		},
	},
	blade5a: {
		title: 'A world of possibilities for developers.',
		paragraphs: [
		'Having worked with AWS for DOOM (2016), Bethesda already had a bunch of in-house knowledge on its myriad capabilities. But AWS brings far more than just familiarity to the mix. It brings vast resources and capabilities. According to Shale Williams, Technology Specialist with id Software—subsidiary of Bethesda and award-winning development studio—AWS opens up nearly limitless possibilities. “With AWS, we’re able to use hardware that’s basically endless,” Williams says. “That’s the kind of a dream all gamers would want.”',
		'Putting all of that on the edge with 5G adds yet more possibilities. According to Duffy, “Running in the edge with Verizon and Amazon is going to let us bring Orion and the games that we build to consumers faster and better. It’s going to help us achieve our goals, and it’s going to be a better experience for everybody."'
		],
		gC: {
			type: 'GroupContainer',
			variant: '',
			classes: 'blade-5a-group-cntnr',
			transitions: {
				aos: {
					name: '',
					delay: '',
					duration: ''
				},
				gsap: {
					components: [],
					script: ''
				}
			},
			presentation: {
				fullWidth: true,
				backgroundAction: 'scroll'
			},
			content: {
				backgroundColor: '',
				backgroundImg: '',
				backgroundVid: '',
				backgroundVidTab: '',
				backgroundVidMob: ''
			}
		},
		featureic1: [
			{
				type: 'FeatureIcon',
				variant: '',
				classes: '',
				transitions: {
					aos: {
						name: '',
						delay: '',
						duration: ''
					},
					gsap: {
						components: [],
						script: bladeAnimations.blade5.icon1
					}
				},
				presentation: {
					svg: true,
					seeTitle: true,
					twoOnMobile: true,
					plus: 'img/plus.svg',
					minus: 'img/minus.svg',
					divider: 'img/Divider.svg'
				},
				content: {
					name: 'fiGroup1',
					idx: 'fi1',
					alt: '5G Icon',
					img: `<svg id="blade5-feat-icon1" role="img" aria-labelledby="svg_title_1" width="66px" height="80px" viewBox="0 0 66 55" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						<!-- Generator: Sketch 61.1 (89650) - https://sketch.com -->
						<title id="svg_title_1">Network Icon</title>
						<desc id="svg_desc_1">Network icon</desc>
						<g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="1">
							<g transform="translate(-167.000000, -6259.000000)" fill="#FFFFFF" fill-rule="nonzero" id="05-A-World-of">
								<g transform="translate(0.000000, 5658.000000)">
									<g id="Featured-Icons" transform="translate(165.000000, 519.000000)">
										<g id="Tile-1" transform="translate(2.000000, 82.000000)">
											<path d="M22.875,24.9944431 L42,66.9944431 L37.5,66.9944431 L35.25,61.7909033 L21,48.7820537 L6.75,61.7909033 L4.5,66.9944431 L0,66.9944431 L19.125,24.9944431 L22.875,24.9944431 Z
											M15.375,43.5785139 L11.625,52.1271865 L18,46.1802838 L15.375,43.5785139 Z
											M27,43.2068325 L24.375,45.8086024 L30.75,51.755505 L27,43.2068325 Z
											M21,30.9413458 L17.25,39.4900183 L21,43.2068325 L24.75,39.4900183 L21,30.9413458 Z"></path>
											<path d="M14,17.8976689 C17.8181818,14.0267012 24.1818182,14.0267012 28,17.8976689 L28,17.8976689 L24.6060606,20.9944431 C22.4848485,19.0589592 19.0909091,19.0589592 17.3939394,20.9944431 L17.3939394,20.9944431 Z" class="wifi-1"></path>
											<path d="M8.5,12.5751566 C15.4230769,5.87748223 26.5769231,5.87748223 33.5,12.5751566 L33.5,12.5751566 L30.4230769,15.5519008 C25.0384615,10.3425985 16.5769231,10.3425985 11.5769231,15.5519008 L11.5769231,15.5519008 Z" class="wifi-2"></path> 
											<path d="M3,7.16814159 C13.0206186,-2.38938053 28.9793814,-2.38938053 39,7.16814159 L39,7.16814159 L36.0309278,10 C27.8659794,2.21238938 14.1340206,2.21238938 5.96907216,10 L5.96907216,10 Z" class="wifi-3"></path>
										</g>
									</g>
								</g>
							</g>
						</g>
					</svg>`,
					subhead: 'Network density',
					caption: '<p>Edge computing is all about location, and Verizon’s buildout in this area creates immediate advantage</p>'
				}
			},
			{
				type: 'FeatureIcon',
				variant: '',
				classes: '',
				transitions: {
					aos: {
						name: '',
						delay: '',
						duration: ''
					},
					gsap: {
						components: [],
						script: bladeAnimations.blade5.icon3
					}
				},
				presentation: {
					svg: true,
					seeTitle: true,
					twoOnMobile: true,
					plus: 'img/plus.svg',
					minus: 'img/minus.svg',
					divider: 'img/Divider.svg'
				},
				content: {
					name: 'fiGroup1',
					idx: 'fi2',
					alt: '5G Icon',
					img: `<?xml version="1.0" encoding="UTF-8"?>
					<svg id="blade5-feat-icon2" role="img" aria-labelledby="svg_title_2" width="76px" height="55px" viewBox="0 0 76 55" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						<!-- Generator: Sketch 61.1 (89650) - https://sketch.com -->
						<title id="svg_title_2">5G Icon</title>
						<desc id="svg_desc_2">5G Icon</desc>
						<g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="1">
							<g transform="translate(-452.000000, -6280.000000)" fill="#FFFFFF" fill-rule="nonzero" id="05-A-World-of">
								<g transform="translate(0.000000, 5658.000000)">
									<g id="Featured-Icons" transform="translate(165.000000, 519.000000)">
										<g id="Tile-2" transform="translate(287.000000, 103.502081)">
											<path d="M16.2058827,0 L16.2058827,45 L11.9117647,45 L11.9117647,0 L16.2058827,0 Z" class="bandwidth-2"></path> 
											<path d="M51.9411768,2.64705882 L51.9411768,42.3529412 L47.6470588,42.3529412 L47.6470588,2.64705882 L51.9411768,2.64705882 Z" class="bandwidth-5"></path> 
											<path d="M28.1176474,6.61764706 L28.1176474,38.3823529 L23.8235294,38.3823529 L23.8235294,6.61764706 L28.1176474,6.61764706 Z" class="bandwidth-3"></path>
											<path d="M63.8529415,7.94117647 L63.8529415,37.0588235 L59.5588235,37.0588235 L59.5588235,7.94117647 L63.8529415,7.94117647 Z" class="bandwidth-6"></path>
											<path d="M40.0294121,10.5882353 L40.0294121,35.7352941 L35.7352941,35.7352941 L35.7352941,10.5882353 L40.0294121,10.5882353 Z" class="bandwidth-4"></path>
											<path d="M4.294118,13.2352941 L4.294118,34.4117647 L-2.23243646e-12,34.4117647 L-2.23243646e-12,13.2352941 L4.294118,13.2352941 Z" class="bandwidth"></path> 
											<path d="M75.7647062,13.2352941 L75.7647062,31.7647059 L71.4705882,31.7647059 L71.4705882,13.2352941 L75.7647062,13.2352941 Z" class="bandwidth-7"></path>
										</g>
									</g>
								</g>
							</g>
						</g>
					</svg>`,
					// img: '/img/icon_laptop.svg',
					subhead: '5G ultra wideband',
					caption: '<p>Millimeter-wave spectrum and small-cell technology deliver leading 5G performance</p>'
				}
			},
			{
				type: 'FeatureIcon',
				variant: '',
				classes: '',
				transitions: {
					aos: {
						name: '',
						delay: '',
						duration: ''
					},
					gsap: {
						components: [],
						script: bladeAnimations.blade5.icon2
					}
				},
				presentation: {
					svg: true,
					seeTitle: true,
					twoOnMobile: true,
					plus: 'img/plus.svg',
					minus: 'img/minus.svg',
					divider: 'img/Divider.svg'
				},
				content: {
					name: 'fiGroup1',
					idx: 'fi3',
					alt: 'Wavelength zone icon',
					img: `<?xml version="1.0" encoding="UTF-8"?>
					<svg id="blade5-feat-icon3" role="img" aria-labelledby="svg_title_3" width="61px" height="63px" viewBox="0 0 61 63" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						<!-- Generator: Sketch 61.1 (89650) - https://sketch.com -->
						<title id="svg_title_3">Zones Icon</title>
						<desc id="svg_desc_3">Wavelength zone icon</desc>
						<g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
							<g transform="translate(-737.000000, -6264.000000)" fill="#FFFFFF" fill-rule="nonzero" id="05-A-World-of">
								<g transform="translate(0.000000, 5658.000000)">
									<g id="Featured-Icons" transform="translate(165.000000, 519.000000)">
										<g id="Tile-3" transform="translate(572.000000, 87.109603)">
											<path d="M0,8.61111111 L20.0588235,0 L40.1176471,8.61111111 L60.1764706,0 L60.1764706,53.3888889 L40.1176471,62 L20.0588235,53.3888889 L0,62 L0,8.61111111 Z M16.7156863,50.6333333 L16.7156863,5.51111111 L3.67745098,11.0222222 L3.67745098,56.1444444 L16.7156863,50.6333333 Z M40.4519608,57.5222222 L56.4990196,50.6333333 L56.4990196,5.85555556 L40.4519608,12.7444444 L40.4519608,57.5222222 Z M36.7745098,56.4888889 L36.7745098,11.3666667 L20.3931373,4.47777778 L20.3931373,49.2555556 L36.7745098,56.4888889 Z" id="Zones-Icon"></path>
										</g>
									</g>
								</g>
							</g>
						</g>
					</svg>`,
					// img: '/img/icon_speed.svg',
					subhead: 'Wavelength zones',
					caption: '<p>Geographically distinctive areas where you are able to place AWS at the edge</p>'
				}
			},
			{
				type: 'FeatureIcon',
				variant: '',
				classes: '',
				transitions: {
					aos: {
						name: '',
						delay: '',
						duration: ''
					},
					gsap: {
						components: [],
						script: bladeAnimations.blade5.icon4
					}
				},
				presentation: {
					svg: true,
					seeTitle: true,
					twoOnMobile: true,
					plus: 'img/plus.svg',
					minus: 'img/minus.svg',
					divider: 'img/Divider.svg'
				},
				content: {
					name: 'fiGroup1',
					idx: 'fi4',
					alt: 'cloud platform icon',
					img: `<?xml version="1.0" encoding="UTF-8"?>
					<svg id="blade5-feat-icon4" role="img" aria-labelledby="svg_title_4" width="86px" height="54px" viewBox="0 0 86 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						<!-- Generator: Sketch 61.1 (89650) - https://sketch.com -->
						<title id="svg_title_4">Cloud Icon</title>
						<desc id="svg_desc_4">cloud platform icon</desc>
						<g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="1">
							<g transform="translate(-1022.000000, -6272.000000)" fill="#FFFFFF" fill-rule="nonzero" id="05-A-World-of">
								<g transform="translate(0.000000, 5658.000000)">
									<g id="Featured-Icons" transform="translate(165.000000, 519.000000)">
										<g id="Tile-4" transform="translate(857.000000, 95.663335)">
											<path d="M48.4736544,4.29328609 C57.7527188,4.30373497 65.2721748,11.7191922 65.2825231,20.8696775 L65.2825231,26.3513599 L70.8412321,26.3513599 C77.1012613,26.3513599 82.1760176,31.3557957 82.1760176,37.52908 C82.1760176,43.7023644 77.1012613,48.7069048 70.8412321,48.7069048 L20.445458,48.7069048 C13.7057968,48.730332 7.60348125,44.781887 4.94229199,38.6756247 C2.28110274,32.5693624 3.57601764,25.4860037 8.23104603,20.6800813 C12.8864786,15.8741589 20.0026477,14.274957 26.3099458,16.6172476 L31.1000986,18.3814554 L33.2817424,13.8210493 C36.0630804,8.02559319 41.9717876,4.31991998 48.4735548,4.29328609 M28.8821044,12.1264406 C20.8585415,9.17348277 11.8223929,11.2223455 5.91245251,17.3345958 C0.00251215145,23.446846 -1.64287354,32.4451693 1.72992541,40.2080967 C5.10272437,47.9710241 12.8440545,53.0032949 21.4081826,53 L69.6411495,53 C78.5706961,53 85.8095238,45.861477 85.8095238,37.0556665 C85.8095238,28.2498561 78.5706961,21.1113363 69.6411495,21.1113363 C69.6411232,9.45196976 60.0566024,4.22772928e-13 48.2334026,4.22772928e-13 C39.9453557,0.00387904704 32.4055084,4.72867301 28.8821044,12.1264406 Z" id="Cloud-Icon"></path>
										</g>
									</g>
								</g>
							</g>
						</g>
					</svg>`,
					// img: '/img/icon_scale.svg',
					subhead: 'Comprehensive platform',
					caption: '<p>The world’s most comprehensive and broadly adopted cloud platform</p>'
				}
			},
		],
	},
	blade6: {
		title: 'Off-the-charts disruption.',
		paragraphs: [
			'So what happens to cloud gaming when 5G, AWS and edge computing all come together? Looking to Bethesda for early inspiration, it appears developers will be able to dream bigger, because virtually unlimited cloud resources will be close to the gamers. Plus, it’ll give mobile devices the ability to run far more advanced games than what’s currently possible, which means expanding gaming out to even larger audiences.',
			'Dreaming bigger and larger audiences—what business isn’t looking to do both? These are a few of the reasons why organizations across industries are excited by the possibilities of Verizon 5G Edge. It offers an unprecedented combination of Verizon’s 5G network and AWS’ industry-leading cloud services brought close to the need. And it promises to change how business is done.'
		],
		ctatarget: '_blank',
		findOutTitle: 'Find out how Verizon can help you transform your customer experience.',
		learnMoreTitle: 'Learn more',
		backgroundImage: '',
		womanImage: require("@/assets/images/Female-Gamer-Background.png"),
		womanImageAltText: 'Woman standing on a balcony playing a game on her phone',
		treeImage: require("@/assets/images/Tree-Overlay.png"),
		transitions: {
			aos: {
				title: {
					name: 'fade-left',
					delay: '',
					duration: ''
				}
			},
		},
		gC: {
			type: 'GroupContainer',
			variant: '',
			classes: 'blade-6-group-cntnr',
			transitions: {
				aos: {
					name: '',
					delay: '',
					duration: ''
				},
				gsap: {
					components: [],
					script: ''
				}
			},
			presentation: {
				fullWidth: true,
				backgroundAction: 'scroll'
			},
			content: {
				backgroundVid: '',
				backgroundVidTab: '',
				backgroundVidMob: ''
			}
		},
		eBf: {
			type: 'SixBySix',
			variant: '',
			classes: '',
			transitions: {
				aos: {
					name: '',
					delay: '',
					duration: ''
				},
				gsap: {
					components: [],
					script: ''
				}
			},
			presentation: {
				direction: 84
			},
			content: {
				posterUrl: '',
				backgroundVideo: '',
			},
		},
	},
  },
  mutations: {

  },
  actions: {

  }
})
